import withAPIAction from 'helpers/withAPIAction'
import {
  PaymentListReq,
  CreatePaymentReq,
  UpdatePaymentReq,
  PaymentDetailReq,
  PatialPaymentReq,
  CreateCreditReq,
} from './types'
import {
  getPaymentListAction,
  createPaymentAction,
  updatePaymentAction,
  getPaymentDetailAction,
  patialPaymentAction,
  createCreditNoteAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const paymentListAPI = (data: PaymentListReq, token: string, xmid: string) => {
  return withAPIAction<PaymentListReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: `${APIPath.paymentList}?${getRequestString(data)}`,
    data,
    token,
    xmid,
  })(getPaymentListAction)
}

export const createPaymentAPI = (data: CreatePaymentReq, token: string, xmid: string) => {
  return withAPIAction<CreatePaymentReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.createPayment,
    data,
    token,
    xmid,
  })(createPaymentAction)
}

export const updatePaymentAPI = (data: UpdatePaymentReq, token: string, xmid: string) => {
  return withAPIAction<UpdatePaymentReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updatePayment,
    data,
    token,
    xmid,
  })(updatePaymentAction)
}

export const getPaymentDetailAPI = (data: PaymentDetailReq, token: string, xmid: string) => {
  return withAPIAction<PaymentDetailReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getPaymentByID,
    data,
    token,
    xmid,
  })(getPaymentDetailAction)
}

export const patialPaymentAPI = (data: PatialPaymentReq, token: string, xmid: string) => {
  return withAPIAction<PatialPaymentReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.patialPayment,
    data,
    token,
    xmid,
  })(patialPaymentAction)
}

export const createCredutNoteAPI = (data: CreateCreditReq, token: string, xmid: string) => {
  return withAPIAction<CreateCreditReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.createCreditNote,
    data,
    token,
    xmid,
  })(createCreditNoteAction)
}
